import { FunctionComponent, useCallback, useState } from 'react'

import { useTranslation } from 'react-i18next'
import { Navigate as Redirect } from 'react-router-dom'

import { Area, AreaSource } from 'store/area/types'
import { getStatus as getAuditStatus, getAudit } from 'store/audit/auditSlice'
import { tCode } from 'utils/tCode'

import { useAppDispatch } from '../../store/hooks'

import { HeaderTitle } from './HeaderTitle'
import { useAreaProgress } from './hooks/useAreaProgress'

export const AreaHeader: FunctionComponent<{
  area?: Partial<Area>
  group?: AreaSource
}> = ({ area, group = AreaSource.COMPANY }) => {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const [redirect, setRedirect] = useState('')
  const { completed, total } = useAreaProgress({ area, group })
  const tArea = tCode(t)
  const { parent } = area ?? {}

  const onClose = useCallback(() => {
    if (group === AreaSource.COMPANY && parent?.code) {
      dispatch(getAuditStatus(parent.code))
      if (area?.code) {
        dispatch(getAuditStatus(area.code))
      }
    }
    dispatch(getAudit())
    setRedirect(`/assessment/${parent?.code || ''}`)
  }, [area, dispatch, group, parent])

  if (redirect) {
    return <Redirect to={redirect} />
  }

  return (
    <HeaderTitle
      confirmMessage={t('confirm.areYouSure')}
      onClose={onClose}
      title={tArea(area?.code, 'title', area?.title)}
      completed={completed}
      total={total}
    />
  )
}
